import React from "react";

const CPP_Inheritance = () => {
  return (
    <div>
      <h1>CPP_Inheritance Component</h1>
      <p>Content for CPP_Inheritance goes here...</p>
    </div>
  );
};

export default CPP_Inheritance;
